import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Grid from '../../elements/grid'
import LinkButtonAlt from '../../elements/linkButtonAlt'
import InnerWrapper from '../../elements/innerWrapper'
import { breakpoint, getColor } from '../../shared/theme'

import SectionTransition from '../../elements/activeSectionDefault'
import OneColumnSlider from '../../components/oneColumnSlider'
import Wyswyg, { Content } from '../../elements/wyswyg'

const OneColumnContent = styled.div``

const OneColumnWrapper = styled(SectionTransition)`
	padding: 48px 0 60px;
	background: ${(props) =>
		props.colorTheme === 'dark' ? getColor('black') : 'transparent'};

	color: ${(props) =>
		props.colorTheme === 'dark' ? getColor('white') : getColor('black')};

	@media ${breakpoint('tablet')} {
		padding: ${(props) => (props.spacing == 'large' ? '200px 0' : '136px 0')};
	}
`

const OneColumnInner = styled.div`
	grid-column: -1 / 1;

	@media ${breakpoint('tablet')} {
		grid-column: 2 / span 8;
	}

	@media ${breakpoint('laptop')} {
		grid-column: 2 / span 7;
	}

	@media ${breakpoint('desktop')} {
		grid-column: 3 / span 7;
	}
`

const ContentWrap = styled(Content)`
	width: 100%;
`

const LinkWrap = styled.div`
	margin-top: 48px;

	@media ${breakpoint('tablet')} {
		margin-top: 54px;
	}
`

const OneColumn = ({
	spacing,
	colourTheme,
	gallery,
	content,
	isActive,
	link,
}) => {
	const [hasSlider, togglerSlider] = useState(gallery && gallery.length > 0)

	return (
		<OneColumnWrapper
			hasSlider={hasSlider}
			spacing={spacing}
			colorTheme={colourTheme}
			isActive={isActive}
		>
			<OneColumnContent>
				<InnerWrapper>
					<Grid>
						<OneColumnInner>
							<ContentWrap
								dangerouslySetInnerHTML={{ __html: content }}
								colorTheme={colourTheme}
							/>
							{link && (
								<LinkWrap>
									<LinkButtonAlt
										path={link.url}
										title={link.title}
										target={link.target}
										colorTheme={colourTheme}
									/>
								</LinkWrap>
							)}
						</OneColumnInner>
					</Grid>
				</InnerWrapper>
			</OneColumnContent>
			{gallery && <OneColumnSlider slides={gallery} />}
		</OneColumnWrapper>
	)
}

OneColumn.propTypes = {
	content: PropTypes.string,
	colourTheme: PropTypes.string,
	spacing: PropTypes.string,
	gallery: PropTypes.array,
}

OneColumn.defaultProps = {
	content: '',
	colourTheme: 'light',
	spacing: 'regular',
	gallery: [],
}

export default OneColumn
